import Route from '@ember/routing/route';
import type { RecommendationsModel } from 'lumen/routes/hotel/settings/recommendations';

export default class HotelSettingsRecommendationsRollingReferenceRatesRoute extends Route {
  model(): RecommendationsModel {
    return this.modelFor(
      'hotel.settings.recommendations',
    ) as RecommendationsModel;
  }
}
